import { render } from "./ProgramsArchive.vue?vue&type=template&id=4d1b93da&scoped=true"
import script from "./ProgramsArchive.vue?vue&type=script&lang=js"
export * from "./ProgramsArchive.vue?vue&type=script&lang=js"

import "./ProgramsArchive.vue?vue&type=style&index=0&id=4d1b93da&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1b93da"]])

export default __exports__